/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Missing_HintInputs */



/**
* | output |
* | --- |
* | "This template also works with the apps below. Connect them now and they are added here when you come back. If you create the agent first, turn them on later ..." |
*
* @param {Agent_Templates_Missing_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_missing_hint = /** @type {((inputs?: Agent_Templates_Missing_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Missing_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Vorlage arbeitet auch mit den folgenden Anwendungen. Verbinden Sie sie jetzt, dann werden sie hier ergänzt, sobald Sie zurückkommen. Wenn Sie den Agenten zuerst anlegen, schalten Sie sie später in den Einstellungen des Agenten unter Fähigkeiten ein.")
	return /** @type {LocalizedString} */ ("This template also works with the apps below. Connect them now and they are added here when you come back. If you create the agent first, turn them on later under Abilities in the agent's settings.")
});